import React from 'react';
import { SubTableWrapperCell } from './Table.styles';

const SubTableWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <tr>
    <SubTableWrapperCell>{children}</SubTableWrapperCell>
  </tr>
);

export default SubTableWrapper;
